export default function (element, data) {
    window.addEventListener("open-popup-menu", function () {
        element.classList.add("open");
        document.body.classList.add('no-scroll');
    });

    window.addEventListener("close-popup-menu", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });

    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-popup-menu'));
    });
    element.querySelector(".menu-mobile").addEventListener("click", function (event) {
        event.stopPropagation();
    });
};